export default __webpack_public_path__ + "static/media/4.ca3d3b3c.webp";